import { Text } from '@shared/components';
import { ODPair } from '@shared/plugin/pages/Quotes/components/QuoteRow';
import { intersperseElements } from '@shared/plugin/utils/intersperseElements';
import { getStopCount } from 'clerk_common/templates/freight_order/fieldExtractors/fieldExtractors';
import { motion } from 'framer-motion';

interface RouteSummaryProps {
  expanded: boolean;
  extractedData: any;
}

export const RouteSummary = ({
  expanded,
  extractedData,
}: RouteSummaryProps) => {
  const stopCount = getStopCount(extractedData);
  return (
    <motion.div
      initial={{ height: 0 }}
      animate={{ height: expanded ? 'auto' : 0 }}
      transition={{ duration: 0.25 }}
      className="overflow-hidden"
    >
      <motion.div
        initial={{ height: 0 }}
        animate={{ height: expanded ? 'auto' : 0 }}
        transition={{ duration: 0.25 }}
      >
        <div className="flex w-full flex-row items-center gap-2 px-4 pb-2 text-gray-700">
          {intersperseElements([
            <ODPair key={'od-pair'} extractedData={extractedData} />,
            <Text
              type="body-xs"
              className="flex-shrink-0 text-gray-700"
              key={'stop-count'}
            >{`${stopCount} stop${stopCount > 1 ? 's' : ''}`}</Text>,
          ])}
        </div>
      </motion.div>
    </motion.div>
  );
};
